import layout from '@/views/layout/layout.vue'
const packingRuleList = r => require.ensure([], () => r(require('@/views/antiChannelConflict/packingRule/list.vue')), 'group-antiChannelConflict-packingRule')

const antiChannelConflictPackingRule = [
  {
    path: '/antichannelconflict/packingRule',
    name: 'antiChannelConflict-packingRule',
    component: layout,
    redirect: '/antichannelconflict/packingRule/list',
    children: [
      {
        path: 'list',
        component: packingRuleList,
        name: 'antiChannelConflict-packingRule-list',
        meta: {
          displayName: '配码管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default antiChannelConflictPackingRule



// WEBPACK FOOTER //
// ./src/router/antiChannelConflict/packingRule.js